import React from 'react'
import { uniqueId } from 'lodash-es'

interface IProps {
  value?: string
  name?: string
  label?: string
  onChange?: (value: string) => void
  hasError?: boolean
  disabled?: boolean
  className?: string
}

function RadioBtn(props: IProps): React.ReactElement {
  const name = React.useRef(props.name ?? props.label ?? 'radio-btn')
  const id = React.useRef(uniqueId(name.current))

  return (
    <div
      className={`radio-btn ${props.className ?? ''} ${
        props.hasError ? '_has-error' : ''
      } ${props.disabled ? '_disabled' : ''}`.trim()}
    >
      <label htmlFor={id.current}>
        <input
          type="radio"
          id={id.current}
          name={name.current}
          checked={
            typeof props.value !== 'undefined'
              ? props.value === name.current
              : undefined
          }
          value={name.current}
          onChange={(e) => {
            props.onChange?.(e.target.value)
          }}
        ></input>

        <span></span>
        {props.label}
      </label>
    </div>
  )
}

export default RadioBtn
